import { enumify, Enumify } from '@mews/enumify';

function BaseDateShift() {}

const config = {
    IntervalMinusWeek: 'intervalMinusWeek',
    IntervalPlusWeek: 'intervalPlusWeek',
    IntervalPlusTwoWeeks: 'intervalPlusTwoWeeks',
    IntervalPlusThreeWeeks: 'intervalPlusThreeWeeks',
    OtherRestrictionSuggestions: 'otherRestrictionSuggestions',
};

type Keys = keyof typeof config;
enumify<Keys, string>(BaseDateShift, 'DateShift', config);

export const DateShift = BaseDateShift as unknown as Enumify<Keys, string>;

export enum HourlyDateShift {
    IntervalMinusDay = 'intervalMinusDay',
    IntervalPlusDay = 'intervalPlusDay',
    IntervalPlusThreeDays = 'intervalPlusThreeDays',
    IntervalPlusTwoDays = 'intervalPlusTwoDays',
    OtherRestrictionSuggestions = 'otherRestrictionSuggestions',
}
